import React from 'react';
import { ContentTemplate, Divider, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import GeneralPrivacyStatement from '../../modules/helpdesk/privacyStatement/GeneralPrivacyStatement';
import UseOfDataPrivacyStatement from '../../modules/helpdesk/privacyStatement/UseOfDataPrivacyStatement';
import ProtectionOfDataPrivacyStatement from '../../modules/helpdesk/privacyStatement/ProtectionOfDataPrivacyStatement';
import ContactInformationPrivacyStatement from '../../modules/helpdesk/privacyStatement/ContactInformationPrivacyStatement';

const PrivacyStatement = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('helpdesk->>PageTitle.Privacy Statement')} />

      <ContentTemplate>
        <GeneralPrivacyStatement />
        <Divider />
        <UseOfDataPrivacyStatement />
        <Divider />
        <ProtectionOfDataPrivacyStatement />
        <Divider />
        <ContactInformationPrivacyStatement />
      </ContentTemplate>
    </>
  );
};

export default PrivacyStatement;
